import * as React from "react";
import { SVGProps } from "react";
export function MemberSpeakingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={31}
      height={31}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#member-speaking_svg__a)"
        stroke="#E27179"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m11.212 6.614 3.486 6.572a1.43 1.43 0 0 1-1.343 1.914h-1.429v2.857a1.429 1.429 0 0 1-1.428 1.429H7.64v5M8.771 10.457a.357.357 0 0 1 0-.714M8.773 10.457a.357.357 0 0 0 0-.714M17.797 15.1a4.086 4.086 0 0 1 0 5.786M20.914 12.243a8.131 8.131 0 0 1 0 11.5" />
      </g>
      <defs>
        <clipPath id="member-speaking_svg__a">
          <path fill="#fff" transform="translate(5.5 5.5)" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
